import RecallVinSearchPage from './RecallVinSearchPage';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { injectIntl } from 'react-intl';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import { setCustomerVehicle } from 'store/reducers/appointment/actions';
import {
  getDecodeVIN,
  setDecodedVINtoAppt
} from 'store/reducers/vehicle/actions';
import {
  getRecallDeferredServices,
  setRecallServices
} from 'store/reducers/recall/actions';

// Selectors
import { getVehicle, getMileage } from 'store/reducers/appointment/selectors';
import { getAutoRecalls } from 'store/reducers/recall/selectors';
import { getDealerCountryCode } from 'store/reducers/dealerSettings/selectors';

const mapStateToProps = state => {
  return {
    vehicle: getVehicle(state),
    autoRecalls: getAutoRecalls(state),
    dealerCountryCode: getDealerCountryCode(state),
    currentMileage: getMileage(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      goTo,
      getDecodeVIN,
      setDecodedVINtoAppt,
      getRecallDeferredServices,
      setCustomerVehicle,
      setRecallServices
    },
    dispatch
  );

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(RecallVinSearchPage);



// WEBPACK FOOTER //
// ./src/components/pages/RecallVinSearchPage/RecallVinSearchPageContainer.js